export default __webpack_public_path__ + "static/media/Deepak_Singh_Resume.e1cae8cb.pdf";